<template>
  <ServiceList
    title="Solicitações"
    :data="services"
    :loading="loading"
    :searchForm="searchForm"
    :pagination="pagination"
    @change-page="getServices"
    scope="outbox"
  ></ServiceList>
</template>

<script>

import serviceRepository from "#repositories/serviceRepository";
import organizationsRepository from "#repositories/organizationsRepository";
import ServiceList from "#views/service/components/ServiceList.vue";
import { request } from "#repositories/repository";
import Badge from "#components/Badge.vue";

export default {
  name: "ServicesOutbox",
  components: {
    ServiceList,
    Badge
  },
  data() {
    return {
      loading: true,
      services: [],
      organizations: [],
      searchTimer: null,
      searchForm: {
        term: this.$route.query.term,
        source_service_priority_id: this.$route.query.source_service_priority_id,
        service_status_id: this.$route.query.service_status_id
      },
      pagination: {
        page: this.$route.query.page ?? 1,
        per_page: 12,
        last_page: 0,
        links: []
      },
    }
  },
  methods: {
    async getOrganizations() {
      this.organizations = (await organizationsRepository.getOrganizations()).data;
    },
    async getServices(page = 0) {
      if(page !== 0) this.pagination.page = page;

      this.loading = true;

      this.$router.push({
         path: this.$route.path, 
         query: {
          page: this.pagination.page,
          term: this.searchForm.term,
          source_service_priority_id: this.searchForm.source_service_priority_id,
          service_status_id: this.searchForm.service_status_id
        } 
      });

      this.services = request.pagination(
          await serviceRepository.getServicesOutbox({
            term: this.searchForm.term,
            source_service_priority_id: this.searchForm.source_service_priority_id,
            service_status_id: this.searchForm.service_status_id,
            ...this.pagination
          }),
          this.pagination
      );

      this.loading = false;
    },
    serviceRoute(item) {
      if (item.person_id) {
        return {
          path: `/person/${item.item.person_id}/services/${item.item.serviceid}`,
          params: {
            id: item.item.person_id
          }
        }
      } else {
        return {
          path: `/service/${item.item.serviceid}`
        }
      }
    },
    searchService(){
      clearTimeout(this.searchTimer);

      this.searchTimer = setTimeout(() => {
        this.pagination.page = 1;
        this.getServices();
      }, 750);
    },
  },
  async mounted() {
    await this.getOrganizations();
    await this.getServices();
  },
  created() {
    ['searchForm.source_service_priority_id', 'searchForm.term', 'searchForm.service_status_id'].forEach(search => {
      this.$watch(search, this.searchService);
    });
  },
  watch: {
    services(newer){
      newer.forEach(service => {
        let organizations_procedure = [];
        service.organizations.forEach(organization_service => {
          organizations_procedure.push(
              this.organizations.find(organization => organization.id === organization_service.organization_id).name
          );
        });
        service.organization = organizations_procedure;
      });
    }
  }
};
</script>
